import { createSelector } from 'reselect'

const getLessons = createSelector(
	[state => state.libraries],
	libraries => ({
		privateLibraryId: libraries.current.libraryUID,
	})
)

export default getLessons
